export default "__VITE_ASSET__B0WR20Id__"